import PartnersOrder from "./PartnersOrder";

export default PartnersOrder;
